webpackJsonp([226020273838829],{

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _Paths = __webpack_require__(14);
	
	var Paths = _interopRequireWildcard(_Paths);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pricing = function (_React$Component) {
	  _inherits(Pricing, _React$Component);
	
	  function Pricing(props) {
	    _classCallCheck(this, Pricing);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Pricing.prototype.componentDidMount = function componentDidMount() {
	    (0, _utils.seoPageChange)();
	  };
	
	  Pricing.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PricingPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white" }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain ' }),
	      _react2.default.createElement(
	        'div',
	        { className: 's10 grid-restrain ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-row h-align feature-table full-8' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-item grid-row card sr4 full-s5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item feature-plan grid-row grid-column' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                'Free'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'core' },
	                '+ SnapTest Features'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'core' },
	                '+ All SnapTest Generators'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'features' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Local mode'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Run Configs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Results'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Private mode'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Draft mode'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Data Driven Testing'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Form, SEO, Spelling Scans'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'grid-item' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'price' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '$0/month'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pt-button pt-intent-primary3 pt-large', href: 'https://chrome.google.com/webstore/detail/snaptest/aeofjocnhdlleichkjbaibdbicpcddhp?hl=en-US' },
	                  '+ Download'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-item grid-row card sr4 full-s5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item feature-plan grid-row grid-column premium' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                'Cloud'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'core' },
	                '+ SnapTest Cloud Features'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'core' },
	                '+ All SnapTest Generators'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'features' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Auto-saving'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Syncing cross devices'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Test Archiving'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Persistence of results'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Cloud execution of tests'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'grid-item' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'price' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '$14.99/month'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'pt-button pt-intent-primary2 pt-large', onClick: function onClick() {
	                      return _this2.props.history.push(Paths.PREMIUM);
	                    } },
	                  '+ Get Cloud'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-item grid-row card sr4 full-s5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item feature-plan grid-row grid-column team' },
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                'Teams'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'core' },
	                'SnapTest Tool'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'core' },
	                'SnapTest Generators'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'features' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Shared account'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Projects'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ 3 seats ($69.99 per additional seat)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new' },
	                  '+ Team collaboration features'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Audit log'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'new construct' },
	                  '+ Projects overview dashboard'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'grid-item' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'price' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '$360/month'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'pt-button pt-intent-primary3 pt-large', onClick: function onClick() {
	                      return _this2.props.history.push(Paths.TEAMS);
	                    } },
	                  '+ Create Team'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_marketing.Footer, null)
	    );
	  };
	
	  return Pricing;
	}(_react2.default.Component);
	
	exports.default = Pricing;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-7688651e925a69a13ab2.js